var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNairaInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66732 14V6.70133C6.66727 6.54622 6.71875 6.39548 6.81366 6.27279C6.90858 6.1501 7.04156 6.06242 7.19171 6.0235C7.34187 5.98459 7.5007 5.99666 7.64326 6.0578C7.78581 6.11895 7.90402 6.22572 7.97932 6.36133L12.022 13.6387C12.0973 13.7743 12.2155 13.881 12.358 13.9422C12.5006 14.0033 12.6594 14.0154 12.8096 13.9765C12.9597 13.9376 13.0927 13.8499 13.1876 13.7272C13.2825 13.6045 13.334 13.4538 13.334 13.2987V6M5.33398 8.66667H14.6673M5.33398 11.3333H14.6673",
    stroke: "white",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaInactive);
export default __webpack_public_path__ + "static/media/naira-inactive.c6ec482f3392cf63dab7db97b5d85bab.svg";
export { ForwardRef as ReactComponent };